import { CreateGRNDBEffects } from './create-grn/create-grn.effects';
import { MaterialRequestsDBEffects } from './material-requests/material-requests.effects';
import { StorageDBEffects } from './storage/storage.effects';
import { TransferDBEffects } from './transfer/transfer.effects';

export const Organizi8AppDBEffects = [
  CreateGRNDBEffects,
  StorageDBEffects,
  MaterialRequestsDBEffects,
  TransferDBEffects,
];
